import { FileUpload } from "../../../../../components/FileUpload";

export default function UploadSignature({setFiles}) {
    return (
        <div className="p-3 border-2 border">
            <FileUpload 
                files={null}
                setFiles={setFiles}
                maxFiles={1}
                className="fileupload-bg"
            />

        </div>
    );
}
